export type ErrorCode = 'storage' | 'maintenance' | 'conflict' | 'missing' | 'validation' | 'operation' | 'attachment' | 'generation';
export class NookError extends Error {
  constructor(public code: ErrorCode, message: string) { super(message); this.name = 'NookError'; }
}
export function errorMessage(error: unknown): string {
  if (error instanceof NookError) return error.message;
  if (error instanceof Error && (error.name === 'QuotaExceededError' || /quota/i.test(error.message))) return '本机空间不足，尚未保存。请保留输入，复制或导出文本后再处理空间。';
  return '尚未保存。输入仍保留在这里，请重试、复制或导出文本。';
}
